import React, {Component} from 'react';
import { Col, Container, Row, Alert } from 'reactstrap';
import TestUserList from '../TestUserList';
import {FaCheckCircle } from 'react-icons/fa';
import axios from 'axios';
import { connect } from 'react-redux';
import { getAuthToken } from '../../../store/utility';
import SitAndReachErgebnisInput from './SitAndReachErgebnisInput';

class SitAndReach extends Component {
    state = {
        showSaveButton: true,
        showSuccessAlert: false,
        sitAndReachErgebnisse: [],
        SitAndReachErgebnis: [0.0, 0.0]
    }

    componentWillReceiveProps() {
        const token = getAuthToken();
        axios.get(this.props.apiUri + 'SitAndReach/GetSitAndReachErgebnisseOfTest?pTestID=' + this.props.testID, {headers: {'Authorization': `Bearer ${token}`}})
            .then(response => {
                this.setState({
                    sitAndReachErgebnisse: response.data
                });
            });
    }

    componentDidMount() {
        const token = getAuthToken();
        axios.get(this.props.apiUri + 'SitAndReach/GetSitAndReachErgebnisseOfTest?pTestID=' + this.props.testID, {headers: {'Authorization': `Bearer ${token}`}})
            .then(response => {
                this.setState({
                    sitAndReachErgebnisse: response.data
                });
            });
    }

    SitAndReachErgebnisChangedHandler = (versuch, value) =>{
        if (value === "") {
            value = "0.0";
        }
        let newSitAndReachErgebnis = [...this.state.SitAndReachErgebnis];
        if (value === "-") {
            newSitAndReachErgebnis[versuch - 1] = value;
        }
        else {
            newSitAndReachErgebnis[versuch - 1] = parseFloat(parseFloat(value).toFixed(1));
        }
        this.setState({
            SitAndReachErgebnis: newSitAndReachErgebnis
        });
    }


    activeTeilnehmerChangedHandler = (selected) => {
        let newSitAndReachErgebnis = ["0.0", "0.0"]
        this.setState({
            SitAndReachErgebnis: newSitAndReachErgebnis,
            showSaveButton: true,
            showSuccessAlert: false
        });
        this.props.changed(selected);
    }

    saveSitAndReachErgebnis = () => {
        axios.post(this.props.apiUri + 'SitAndReach?pKindID=' + this.props.activeTeilnehmerID + '&pTestID=' + this.props.testID + '&pV1=' + this.state.SitAndReachErgebnis[0] + '&pV2=' + this.state.SitAndReachErgebnis[1], null, {headers: {'Authorization': `Bearer ${this.props.token}`}})
            .then(response => {
                axios.get(this.props.apiUri + 'SitAndReach/GetSitAndReachErgebnisseOfTest?pTestID=' + this.props.testID, {headers: {'Authorization': `Bearer ${this.props.token}`}})
                    .then(response => {
                        this.setState({
                            sitAndReachErgebnisse: response.data,
                            showSaveButton: false,
                            showSuccessAlert: true
                        });
                    })
            })
    }

    render() {
        let sitAndReachErgebnisse = [...this.state.sitAndReachErgebnisse];
        let showSaveButton = this.state.showSaveButton; // wird überschrieben, wenn Ergebnis bereits vorhanden ist

        let sitAndReachAnleitung = (
            <div>
                <p>Hier bitte die Ergebnisse eintragen.</p>
            </div>
        );

        let sitAndReachTeilnehmer = [...this.props.testUsers];
        sitAndReachTeilnehmer.forEach(function (testUser) {
            if (sitAndReachErgebnisse.length > 0 && sitAndReachErgebnisse.some(ergebnis => ergebnis.kindID === testUser.id)) {
                testUser.uebungAbsolviertSymbol = <FaCheckCircle size={16} />;
                testUser.uebungAbsolviert = "JA";
            }
            else {
                testUser.uebungAbsolviert = "NEIN";
                testUser.uebungAbsolviertSymbol = "";
            }
        });

        let index = [...this.props.selected];
        if (sitAndReachTeilnehmer !== undefined && sitAndReachTeilnehmer[index[0]] !== undefined) {
            if (sitAndReachTeilnehmer[index[0]].uebungAbsolviert === "JA") {
                showSaveButton = false;
            }
        }

        let saveSitAndReachErgebnisButton = null;
        let sitAndReachErgebnisInput = null;

        if (showSaveButton) {
            // Zu diesem Kind wurde noch kein SitAndReach Ergebnis gespeichert
            sitAndReachErgebnisInput = (
                <div>
                    <SitAndReachErgebnisInput
                        SitAndReachErgebnis={this.state.SitAndReachErgebnis}
                        onChange={(number, value) => this.SitAndReachErgebnisChangedHandler(number, value)}
                    />
                </div>
            );

            saveSitAndReachErgebnisButton = (
                <div><button
                    className="btn btn-primary"
                    onClick={() => this.saveSitAndReachErgebnis()}
                    type="button"> Ergebnis speichern
                </button>
                </div>
            );
        }
        else {
            // Es wurde bereits ein SitAndReach Ergebnis gespeichert
            let currentUserSitAndReachErgebnis = sitAndReachErgebnisse.filter(ergebnis => ergebnis.kindID === this.props.activeTeilnehmerID);
            const style = {
                display: 'block ruby',
                padding: '10px'
            };
            if (currentUserSitAndReachErgebnis.length > 0) {
                sitAndReachErgebnisInput = (
                    <div>
                        <h4>Gespeicherte Ergebnisse</h4>
                        <h5 style={style}>Versuch 1: {currentUserSitAndReachErgebnis[0].v1}</h5>
                        <h5 style={style}>Versuch 2: {currentUserSitAndReachErgebnis[0].v2}</h5>
                    </div>
                );
            }
        }

        if (this.state.showSuccessAlert) {
            saveSitAndReachErgebnisButton = (
                <Alert color="success">Sit And Reach Ergebnis von {this.props.activeTeilnehmerVorname} wurde gespeichert!</Alert>
            );
        }

        return (
            <div>
                <Container>
                    <Row>
                        <Col xs="3">
                            <TestUserList
                                id="sitAndReachTeilnehmer"
                                testUsers={sitAndReachTeilnehmer}
                                selected={this.props.selected}
                                changed={(selected) => { this.activeTeilnehmerChangedHandler(selected) }} />
                        </Col>
                        <Col>
                            <h3>{this.props.activeTeilnehmerVorname} führt Sit And Reach durch:</h3>
                            {sitAndReachAnleitung}
                            {sitAndReachErgebnisInput}
                            {saveSitAndReachErgebnisButton}
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    };   
};

const mapStateToProps = state => {
    return {
        apiUri: state.apiUri,
        token: state.token,
        username: state.username
    };
  };

export default connect(mapStateToProps)(SitAndReach);